import flatpickr from "flatpickr";
import dayjs from 'dayjs';
import { getSettings, clear, getElementFromString, getEvent } from './components/functions';
import TableLayout from './components/TableLayout';
import Validation from './components/singleEventValidation';
import 'element-closest-polyfill';
import QtyButtons from './components/qtyButtons';

class SingleEvent {
	constructor() {
		this.elements = {
			form: document.querySelector('.event-cart'),
			tabs: [...document.querySelectorAll('.event-tab-button')],
			hidden: document.getElementById('hpy_event_type'),
			table: document.querySelector('.events--booking'),
			date: document.getElementById('hpy_event_date'),
			time: document.getElementById('hpy_event_time'),
			qty: document.querySelector('.event-cart .quantity input.qty'),
			id: document.getElementById('hpy_event_id'),
			redeem: document.getElementById('hpy_event_voucher_code'),
			tableHidden: document.getElementById('hpy_event_table_id'),
			price: document.querySelector('.event-cart .event--cart .price'),
			coupon: document.getElementById('hpy_event_voucher_code'),
			wrap: document.querySelector('.event-tabs-wrapper'),
			wishlist: document.getElementById('hpy-event-wishlist-form'),
			wishlist_id: document.getElementById('hpy-event-wishlist-id'),
			addons: [...document.querySelectorAll('.hpy-event-addons_addon')]
		};

		if (!this.elements.form) {
			return;
		}

		this.settings = getSettings();
		this.state = {
			loadingTimes: false,
			events: null,
			dates: null,
			selectedEvents: null,
			type: null,
			ticketed: hpy_single_event.ticketed === '1'
		};

		this.ajax = {
			times: false
		};

		this.cache = [];

		this.state.unitPrice = parseFloat(hpy_single_event.unit_price).toFixed(2);

		this.calendar = null;
		this.validation = new Validation(this.elements, this.state);

		this.getEventsData();
		this.initDOMEvents();
		this.initCalendar();

		new QtyButtons(jQuery('.event-cart input.qty'));
	}

	initDOMEvents() {
		this.elements.time.addEventListener('change', this.timeSelected.bind(this));


		this.elements.tabs.forEach(tab => tab.addEventListener('click', this.tabChange.bind(this)));
		if (this.elements.tabs.length) {
			if (this.state.events) {
				this.tabChange({ target: this.elements.tabs[0] });
			} else {
				this.elements.tabs[0].parentNode.remove();
				this.tabChange({ target: this.elements.tabs[1] });
			}
		} else {
			this.tabChange({ target: { dataset: { key: 'free' } } });
		}

		jQuery(this.elements.qty).on('change input', this.updatePrice.bind(this));
		jQuery(document.body).on('wc_fragments_refreshed wc_fragments_loaded', this.fragment.bind(this));

		if (this.elements.addons.length) {
			this.elements.addons.forEach(addon => {
				addon.querySelector('select').addEventListener('change', this.updatePrice.bind(this));
			})
		}

	}

	fragment() {
		const fragments = jQuery.parseJSON(sessionStorage.getItem(wc_cart_fragments_params.fragment_name));
		if (fragments && fragments.event_availability) {
			this.availability = fragments.event_availability;
			this.getEventsData();
			this.initCalendar();
		}
	}

	tabChange(e) {
		const isSingle = e.target.dataset.key === 'free';
		const target = isSingle ? e.target : e.target.closest('.event-tab-button');
		const key = isSingle ? 'book' : target.dataset.key;

		if (isSingle) {
			this.maybeChangeToCustomTab(target);
		}

		if (this.elements.tabs.length) {
			this.elements.tabs.forEach(tab => tab.classList.remove('active'));
			target.classList.add('active');
		}

		this.state.type = key;
		this.elements.hidden.value = this.state.type;
		this.elements.tableHidden.value = '';

		if (key === 'book' || key === 'redeem') {
			this.elements.time.dispatchEvent(getEvent('change')); // trigger a change event to update the spaces
		} else {
			this.elements.qty.removeAttribute('max');
			this.showHideRows(key, 0);
		}

		this.updatePrice();
	}

	maybeChangeToCustomTab(target) {
		if (target.classList.contains('hpyev_custom_tab_button')) {
			const customTab = this.elements.wrap.querySelector(`.hpyev_custom_tab[data-key="${target.dataset.key}"]`);
			if (customTab) {
				customTab.style.display = 'block';
				this.elements.form.style.display = 'none';
			}
		} else {
			const customTabs = [...this.elements.wrap.querySelectorAll(`.hpyev_custom_tab`)];
			if (customTabs && customTabs.length) {
				customTabs.forEach(tab => tab.style.display = 'none');
			}
			this.elements.form.style.display = 'block';
		}
	}

	setGalleryHeight() {
		const gallery = document.querySelector('.sp--gallery_wrap');
		if (gallery) {
			gallery.style.maxHeight = document.querySelector('.summary').offsetHeight + 'px';
		}
	}

	showHideRows(key, spaces) {

		const rows = [...this.elements.table.querySelectorAll(`tr:not(.show), .hpy-event-wishlist-form`)];

		if (this.elements.wishlist) {
			rows.push(this.elements.wishlist);
		}

		let selector = spaces > 0 ? `tr.show-${key}` : `tr.show-${key}:not(.hide-empty)`;
		if (key === 'voucher') {
			selector = `tr.show-${key}`;
		}

		const show = [...this.elements.table.querySelectorAll(selector + ', tr.show-force')];
		if (this.elements.wishlist && 'booked' === key) {
			show.push(this.elements.wishlist);
		}

		rows.forEach(row => row.classList.remove('visible'));
		if (show) {
			show.forEach(row => row.classList.add('visible'));
		}

		if (this.state.type === 'redeem') {
			this.elements.table.querySelector('.redeem-voucher').classList.add('visible');
		}

		this.setGalleryHeight();
	}

	getEventsData() {
		if (this.elements.form && this.elements.form.dataset.events) {
			this.state.events = JSON.parse(this.elements.form.dataset.events); // read the events
			this.state.dates = [];

			this.state.events.forEach(event => {

				event.spaces = this.alterSpacesCountFromCart(event); // parse spaces to an intger for comparisons later
				event.tabled = event?.tabled && event.tabled === 'true';

				if (event.tabled && event?.tables?.length) {
					event.tables.forEach(table => {
						table.min = parseInt(table.min);
						table.max = parseInt(table.max);
						table.qty = this.alterTableCountFromCart(event, table);
					});
				}

				event.total = this.getAvailableTables(event);

				this.state.dates.push(event.select_date);
			});

			this.state.dates = [...new Set(this.state.dates)]; // filter only unique dates
			this.state.dates.sort((a, b) => dayjs(a).isAfter(dayjs(b)) ? 1 : -1); // sort
		}

	}

	alterSpacesCountFromCart(event) {
		let qty = parseInt(event.spaces);

		if (this.availability) {
			if (this.availability[event.id]) {
				qty = qty - this.availability[event.id];
			}
		}

		return qty;
	}

	// alter the data read in by removing tables that have already been added by this user
	alterTableCountFromCart(event, table) {
		let qty = parseInt(table.qty);

		if (this.availability) {
			if (this.availability[event.id] && this.availability[event.id][table.id]) {
				qty = qty - this.availability[event.id][table.id];
			}
		}

		return qty;
	}

	initCalendar() {
		if (!document.querySelector('.event-tab-button[data-key="book"]')) {
			return;
		}

		const settings = {
			minDate: "today",
			altInput: true,
			altFormat: "F j, Y",
			dateFormat: "Y-m-d",
			defaultDate: this.state.dates[0],
			enable: this.state.dates,
			maxDate: this.getMinMaxDate(),
			wrap: true,
			onChange: (dObj, dStr, fp) => this.datePickrChanged(fp.selectedDates[0]),
			onReady: (dObj, dStr, fp) => this.datePickrChanged(fp.selectedDates[0]),
			onDayCreate: (dObj, dStr, fp, dayElem) => {
				const date = dayjs(dayElem.dateObj).format(this.settings.format);

				if (this.isEventFull(date)) {
					dayElem.classList.add('full');
				}
			},
		};

		if (this.elements.date.value) {
			settings.defaultDate = this.elements.date.value;
		} else {
			// get the soonest available date with spaces.
			const firstWithSpaces = this.state.dates.find(date => {
				date = dayjs(date).format(this.settings.format);
				return !this.isEventFull(date)
			});

			// set the default date if appropriate.
			if (firstWithSpaces) {
				settings.defaultDate = firstWithSpaces;
			}
		}

		this.calendar = flatpickr(this.elements.date.parentNode, settings);
	}

	getMinMaxDate() {
		const dates = this.state.dates.map((day) => dayjs(day));

		if (!dates.length) {
			return null;
		}

		const maxDate = dates.reduce((accumulator, curVal) => curVal && accumulator.isAfter(curVal) ? accumulator : curVal);

		return maxDate.format(this.settings.format);
	}

	isEventFull(date) {

		if (!this.state.ticketed) {
			return false;
		}

		const events = this.state.events.filter(evt => evt.date === date);
		let full = true;

		if (!events.length) {
			return false;
		}

		events.forEach(evt => {
			if (!evt.tables.length) {
				if (evt.spaces > 0) {
					full = false;
				}
			} else if (evt.tables.length) {
				let qty = evt.tables.reduce((acc, cur) => {
					return { qty: acc.qty + cur.qty };
				});

				if (qty.qty > 0) {
					full = false;
					return;
				}
			}
		});

		return full;
	}

	getAvailableTables(event) {
		if (!event?.tabled) {
			return event.spaces;
		}

		if (!event?.tables && !event.tables.length) {
			return 0;
		}

		let spaces = 0;
		event.tables.forEach(table => spaces += table.qty);

		return spaces;
	}

	getEventsByDate(date) {

		return new Promise((resolve, reject) => {
			if (this.ajax.times) {
				this.ajax.times.abort();
				this.ajax.times = false;
			}

			const cached = this.cache.find(item => item.date === date);
			if (cached) {
				if (cached.events.length) {
					resolve(cached.events);
				} else {
					reject([]);
				}
				return;
			}

			this.ajax.times = jQuery.ajax({
				url: hpy_single_event.rest.url,
				type: 'GET',
				dataType: 'json',
				data: {
					date: date,
					product: hpy_single_event.product_id,
					parse: true
				},
				success: (response) => {
					if (response?.success && response?.data) {
						this.cache.push({ date: date, events: response.data });
						resolve(response.data);
					} else {
						this.cache.push({ date: date, events: [] });
						reject([]);
					}
				},
				error: (xhr, status, error) => {
					console.error('Error fetching events:', error);
					reject(false);
				}
			});
		});
	}

	loadingTimes(loading) {
		const parent = this.elements.time.parentNode;
		if (loading) {

			this.elements.time.style.display = 'none';
			parent.querySelector('.hpy_event_time--loading').style.display = 'block';
			parent.querySelector('.input-wrap_suffix').style.display = 'none';
			document.querySelector('.single_add_to_cart_button').disabled = true;
		} else {
			this.elements.time.style.display = 'inline-flex';
			parent.querySelector('.hpy_event_time--loading').style.display = 'none';
			parent.querySelector('.input-wrap_suffix').style.display = 'flex';
			document.querySelector('.single_add_to_cart_button').disabled = false;
		}

		this.state.loadingTimes = loading;
	}

	async datePickrChanged(date) {
		date = dayjs(date).format(this.settings.format);

		try {
			this.showHideRows('book', 0);
			this.loadingTimes(true);
			this.state.selectedEvents = await this.getEventsByDate(date);
			this.ajax.times = false;
			this.loadingTimes(false);

			const times = [...new Set(this.state.selectedEvents.map(event => {
				return {
					time: event.select_time,
					total: event.spaces
				};
			}))];

			clear(this.elements.time);

			times.sort((a, b) => dayjs('2020-1-1 ' + a.time, 'YYYY-M-D HH:mm:ss').isAfter(dayjs('2020-1-1 ' + b.time, 'YYYY-M-D HH:mm:ss')) ? 1 : -1);
			times.forEach(time => {
				const selected = this.elements.time.dataset.time == time.time;
				if (selected) { // remove selected so selected is only chosen on load.
					this.elements.time.dataset.time = '';
				}
				this.elements.time.insertAdjacentHTML('beforeend', `<option value="${time.time}" ${selected ? 'selected' : ''}>${dayjs(date + ' ' + time.time, 'YYYY-MM-DD HH:mm:ss').format(this.settings.prettyTime)}</option>`);
			});

			this.elements.tableHidden.value = '';
			if (this.tables) {
				this.tables.destroy();
				this.tables = null;
			}
			this.setupLayout();

			if (!this.tables) {
				this.elements.time.dispatchEvent(getEvent('change'));
				this.elements.qty.dispatchEvent(getEvent('change'));
			}
		} catch (error) {
			if (false === error) {
				return;
			}

			if (!error || !error.length) {
				this.showHideRows('booked', 0);
				return;
			}
		}
	}

	setupLayout() {
		const event = this.state.selectedEvents.find(event => event.select_time === this.elements.time.value);
		const spaces = event?.tabled ? this.getAvailableTables(event) : event?.spaces;

		if (0 === spaces) {
			this.showHideRows('booked', 0);
			return;
		}


		const hasLayout = this.state.type === 'book' || this.state.type === 'redeem';
		this.state.tabled = hasLayout && event?.tabled && event?.tables && event.tables.length ? 'book-table' : this.state.type;

		if (this.state.tabled === 'book-table') {
			if (!this.tables) {
				this.tables = new TableLayout(event.tables);
				this.tables.setupLayout();
			} else {
				this.tables.tables = event.tables;
				this.tables.showQty();
			}
		} else {
			if (this.tables) {
				this.tables.destroy();
				this.tables = null;
			}
		}

		this.showHideRows(this.state.tabled, spaces);
	}

	timeSelected() {

		if (!this.state.selectedEvents || !this.elements.time.value) {
			this.showHideRows('booked', 0);
			return;
		}

		const event = this.state.selectedEvents.find(event => event.select_time === this.elements.time.value);
		if (!event) {
			alert('Event not found');
			return;
		}

		this.elements.id.value = event.id;
		if (this.elements.wishlist_id) {
			this.elements.wishlist_id.value = event.id
		}

		this.elements.tableHidden.value = '';
		this.setupLayout();

		if (!event.tabled) {
			this.updateQty(event.spaces);

			// reset the input to the max spaces if it exceeds the new max spaces
			this.elements.qty.setAttribute('max', event.spaces);
			if (this.elements.qty.value > event.spaces) {
				this.elements.qty.value = event.spaces;
			}
		}
	}

	updateQty(qty, max) {
		if (this.elements.time.nextElementSibling) {
			this.elements.time.nextElementSibling.innerHTML = `<strong>${qty}</strong> ${qty === 0 || qty > 1 ? 'spaces remaining' : 'space remaining'}`;
			this.elements.time.nextElementSibling.style.display = qty <= (max || 6) ? 'block' : 'none';
		}

	}

	updatePrice() {

		const addonPrice = this.calculateAddOnPrice();
		let price = 0;
		clear(this.elements.price);

		if (this.state.unitPrice > 0) {
			price += (this.elements.qty.value * this.state.unitPrice);
		}

		price += addonPrice;

		if (price <= 0) {
			this.elements.price.innerHTML = hpy_single_event.free_text
		} else {
			this.elements.price.insertAdjacentElement('beforeend', getElementFromString(this.currency(price)));
		}
	}

	calculateAddOnPrice() {
		let price = 0;

		if (this.elements.addons.length) {
			this.elements.addons.forEach(addon => {

				const select = addon.querySelector('select');
				const option = select.querySelector(`option[value="${select.value}"]`);

				if (option) {
					let addonPrice = parseFloat(option.dataset.price);
					if (!isNaN(addonPrice)) {
						price += select.dataset.multi === '1' ? addonPrice * this.elements.qty.value : addon;
					}
				}


			});
		}

		return price;
	}

	currency(value) {
		return `<span class="woocommerce-Price-amount amount"><span class="woocommerce-Price-currencySymbol">${hpy_single_event.currency}</span>${value.toFixed(2)}</span>`;
	}
}

window.hpySingleEvent = new SingleEvent();